var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class DiscoveryApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'discovery-api';
    }
    getRegistry() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: 'discovery-registry' }, options));
        });
    }
    updateEnvironmentDiscoveryData(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/${id}/environments` }, options));
        });
    }
    updateAllEnvironmentsDiscoveryData() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/environments/update-all` }, options));
        });
    }
    getServiceVersionJson(environmentId_1, url_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, url, options = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/version-json`, params: {
                    environmentId,
                    url,
                } }, options));
        });
    }
}
//# sourceMappingURL=index.js.map